import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Slider } from "@mui/material";
import "./SipCalculator.scss";

import { RiRadioButtonFill } from "react-icons/ri";
import CustomButton from "./CustomButton";
import DonutChart from "./DonutChart";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SipCalculator = () => {
  const navigate = useNavigate();

  const [isGold, setIsGold] = useState(true);
  const [switchBtn, setSwitchBtn] = useState(true);

  // const handleBuyGold = () => {
  //   const token = sessionStorage.getItem("token");
  //   if (token) {
  //     if (isGold) {
  //       // navigate(switchBtn ? "/dashboard/gold/buy" : "/dashboard/gold-sip", {
  //       navigate(switchBtn ? "/dashboard/gold/buy" : "/dashboard/gold/sip", {
  //         state: sipValue.slider1,
  //       });
  //     } else {
  //       navigate(
  //         // switchBtn ? "/dashboard/silver/buy" : "/dashboard/silver-sip",
  //         switchBtn ? "/dashboard/silver/buy" : "/dashboard/silver/sip",
  //         {
  //           state: sipValue.slider1,
  //         }
  //       );
  //     }
  //   } else {
  //     let redirectTo = "";
  //     if (isGold === true) {
  //       redirectTo = switchBtn ? "/dashboard/gold/buy" : "/dashboard/gold/sip";
  //     } else {
  //       redirectTo = switchBtn
  //         ? "/dashboard/silver/buy"
  //         : "/dashboard/silver/sip";
  //     }
  //     sessionStorage.setItem("redirectTo", redirectTo);
  //     navigate("/login");
  //   }
  // };

  // ==========================NAGENDER===========

  const handleBuyGold = () => {
    if (sipValue.slider1 < 100) {
      toast.error("Minimum purchase amount is ₹100");
      return;
    } else if (sipValue.slider1 > 1000000) {
      toast.error("Maximum purchase amount is ₹1000000");
      return;
    }
    const token = sessionStorage.getItem("token");
    if (token) {
      if (isGold) {
        navigate(switchBtn ? "/dashboard/gold/buy" : "/dashboard/gold/sip", {
          state: { amount: sipValue.slider1 },
        });
      } else {
        navigate(
          switchBtn ? "/dashboard/silver/buy" : "/dashboard/silver/sip",
          {
            state: { amount: sipValue.slider1 },
          }
        );
      }
    } else {
      let redirectTo = "";
      if (isGold === true) {
        redirectTo = switchBtn ? "/dashboard/gold/buy" : "/dashboard/gold/sip";
      } else {
        redirectTo = switchBtn
          ? "/dashboard/silver/buy"
          : "/dashboard/silver/sip";
      }
      navigate("/login", {
        state: {
          redirectTo: redirectTo,
          amount: sipValue.slider1,
        },
      });
    }
  };

  const goldLivePrice = useSelector((state) => state.goldSlice.data.data);
  const { gBuy, sBuy } = goldLivePrice?.[0]?.[0] || [];

  const [error, setError] = useState("");
  const [durationError, setDurationError] = useState("");

  const [sipValue, setSipValue] = useState({
    slider1: "100",
    slider2: "10",
  });

  const [result, setResult] = useState({
    investAmt: "",
    estReturn: "",
    exptQty: "",
    totalSaving: "",
  });
  const handleSliderChange = (e) => {
    const { value, name } = e.target;
    const updatedSipValue = { ...sipValue, [name]: value };
    setSipValue(updatedSipValue);
    if (switchBtn) {
      handleCalculateSip(updatedSipValue);
    } else {
      handleCalculateMonthlySip(updatedSipValue);
    }
  };

  const handleCalculateSip = (values) => {
    const { slider1, slider2 } = values;
    const result = slider1 * Math.pow(1 + 12 / 100, slider2);
    const rate = isGold ? gBuy : sBuy;
    setResult({
      investAmt: slider1,
      estReturn: result - slider1,
      exptQty: slider1 / rate,
      totalSaving: result,
    });
  };

  // const handleCalculateMonthlySip = (values) => {
  //   const { slider1, slider2 } = values;
  //   const annualInterestRate = 12 / 100;
  //   const monthlyInterestRate = annualInterestRate / 12;

  //   const months = slider2 * 12; // 1 year of monthly investments
  //   const P = slider1; // Monthly investment amount

  //   // Future Value (FV) of a monthly SIP
  //   const futureValue =
  //     P *
  //     (((1 + monthlyInterestRate) ** months - 1) / monthlyInterestRate) *
  //     (1 + monthlyInterestRate);
  //   const rate = isGold ? gBuy : sBuy;
  //   setResult({
  //     investAmt: slider1 * months,
  //     estReturn: futureValue - slider1 * months,
  //     exptQty: (slider1 * months) / rate,
  //     totalSaving: futureValue,
  //   });
  // };

  // ================================================================================
  const handleCalculateMonthlySip = (values) => {
    const { slider1: monthlyInvestment, slider2: years } = values;

    // Constants for SIP calculation
    const annualInterestRate = 0.12; // 12% annual return
    const monthlyInterestRate = annualInterestRate / 12;
    const months = years * 12;

    // Calculate future value using SIP formula
    const futureValue =
      monthlyInvestment *
      (((1 + monthlyInterestRate) ** months - 1) / monthlyInterestRate) *
      (1 + monthlyInterestRate);

    // Physical gold tracking (optional - only if you want to show quantity)
    const appreciationRate = 0.12; // 12% annual gold appreciation
    let currentGoldPrice = isGold ? gBuy : sBuy;
    let totalGold = 0;
    const monthlyAppreciation = Math.pow(1 + appreciationRate, 1 / 12);

    for (let month = 1; month <= months; month++) {
      totalGold += monthlyInvestment / currentGoldPrice;
      currentGoldPrice *= monthlyAppreciation;
    }

    const totalInvestment = monthlyInvestment * months;

    setResult({
      investAmt: totalInvestment,
      estReturn: futureValue - totalInvestment, // Using SIP formula for returns
      exptQty: parseFloat(totalGold.toFixed(3)), // Physical gold quantity
      totalSaving: parseFloat(futureValue.toFixed(2)), // Using SIP formula for total value
    });
  };

  // ================================================================================

  useEffect(() => {
    if (switchBtn) {
      handleCalculateSip(sipValue);
    } else {
      handleCalculateMonthlySip(sipValue);
    }
  }, [gBuy, sBuy, isGold, switchBtn, sipValue]);

  return (
    <div className="universal_card sip_cal_main">
      {/* ========BOX 1===========  */}
      <div
        style={{
          width: "100%",
          padding: "1.5rem 2rem",
          display: "flex",
          flexDirection: "column",
          gap: "2.5rem",
        }}
      >
        {/* ====GOLD&SILVER BTNS====== */}
        <div style={{ display: "flex" }}>
          <button
            className="sip_base_btn"
            style={{
              backgroundColor: isGold ? "#fffaee" : "transparent",
              border: isGold ? "1px solid #bd9300" : "transparent",
              color: "#bd9300",
            }}
            onClick={() => setIsGold(true)}
          >
            <RiRadioButtonFill size={20} />
            Gold
          </button>
          <button
            className="sip_base_btn"
            style={{
              color: "#655F5F",
              backgroundColor: !isGold ? "#e4e4e4" : "transparent",
              border: !isGold ? "1px solid #655F5F" : "transparent",
            }}
            onClick={() => setIsGold(false)}
          >
            <RiRadioButtonFill size={20} />
            Silver
          </button>
        </div>
        {/* RADIO BUTTONS=========  */}
        <div
          style={{
            display: "flex",
            gap: "1.7rem",
            // margin: "2rem auto",
          }}
        >
          <label
            style={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            <input
              type="radio"
              name="option"
              value="sipOneTime"
              checked={switchBtn}
              onChange={() => setSwitchBtn(!switchBtn)}
              style={{ accentColor: "red" }}
            />
            One-Time
          </label>
          <br />
          <label
            style={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            <input
              type="radio"
              checked={!switchBtn}
              onChange={() => setSwitchBtn(!switchBtn)}
              name="option"
              value="sipMonthly"
              style={{ accentColor: "red" }}
            />
            Monthly SIP
          </label>
        </div>
        {/* ======AMT slider=======  */}
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px" }}>
              Savings In Digital {isGold ? "Gold" : "Silver"}:
            </span>
            <div
              style={{
                borderBottom: "1px solid #DCDCDC",
                color: "red",
                fontWeight: "500",
              }}
            >
              ₹
              <input
                type="text"
                value={sipValue.slider1}
                name="slider1"
                className="sip_cal_input"
                onChange={(e) => {
                  let value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setError("");
                    handleSliderChange({ target: { name: "slider1", value } });
                  }
                }}
                onBlur={(e) => {
                  let value = e.target.value;
                  if (value === "") {
                    value = "100"; // Set default if empty
                    setError("Minimum amount should be ₹100");
                  } else {
                    const numericValue = parseInt(value, 10);
                    if (numericValue < 100) {
                      value = "100";
                      setError("Minimum amount should be ₹100");
                    } else if (numericValue > 1000000) {
                      value = "1000000";
                      setError("Maximum amount should be ₹10,00,000");
                    } else {
                      setError(""); // Clear error if valid
                    }
                  }
                  handleSliderChange({ target: { name: "slider1", value } });
                }}
              />
            </div>
          </div>
          {error && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
              {error}
            </div>
          )}
          <Slider
            value={sipValue.slider1 || 10}
            valueLabelDisplay="auto"
            min={100}
            max={1000000}
            name="slider1"
            onChange={handleSliderChange}
            sx={{
              color: "red",
              "& .MuiSlider-thumb": {
                backgroundColor: "white",
              },
              "& .MuiSlider-rail": {
                backgroundColor: "lightgray",
              },
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "600",
            }}
          >
            <div>₹100</div>
            <div>₹1000000</div>
          </div>
        </div>
        {/* ====== TIMER slider========= */}
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px" }}>Time period</span>
            <div
              style={{
                borderBottom: "1px solid #DCDCDC",
                color: "red",
                fontWeight: "500",
              }}
            >
              <input
                type="text"
                value={sipValue.slider2}
                name="slider2"
                className="sip_cal_input"
                onChange={(e) => {
                  let value = e.target.value;
                  // Allow only digits while typing
                  if (/^\d*$/.test(value)) {
                    setDurationError(""); // Clear error while typing
                    handleSliderChange({ target: { name: "slider2", value } });
                  }
                }}
                onBlur={(e) => {
                  let value = e.target.value;
                  if (value === "") {
                    value = "1"; // Set default if empty
                    setDurationError("Minimum duration should be 1 year");
                  } else {
                    const numericValue = parseInt(value, 10);
                    if (numericValue < 1) {
                      value = "1";
                      setDurationError("Minimum duration should be 1 year");
                    } else if (numericValue > 40) {
                      value = "40";
                      setDurationError("Maximum duration should be 40 years");
                    } else {
                      setDurationError(""); // Clear error if valid
                    }
                  }
                  handleSliderChange({ target: { name: "slider2", value } });
                }}
              />
              Yr
            </div>
          </div>
          {durationError && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
              {durationError}
            </div>
          )}
          <Slider
            value={sipValue.slider2 || 10}
            // value={timePeriod2 || 1}
            valueLabelDisplay="auto"
            min={1}
            max={40}
            // onChange={(e, newValue) => setTimePeriod2(newValue)}
            onChange={handleSliderChange}
            name="slider2"
            sx={{
              color: "red", // changes the track & filled portion
              "& .MuiSlider-thumb": {
                backgroundColor: "white",
                // border: "2px solid red",
              },
              "& .MuiSlider-rail": {
                backgroundColor: "lightgray", // optional, for unfilled track
              },
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "600",
            }}
          >
            <div>1Yr</div>
            <div>40Yr</div>
          </div>
        </div>
      </div>
      {/* ========BOX 2===========  */}
      <div className="sip_cal_box2">
        <div
          style={{
            backgroundColor: "#f4f4f4",
            padding: "1rem",
            borderRadius: "8px",
            boxShadow: "1px 1px 2px 0px #00000014, -1px -1px 2px 0px #00000014",
            fontSize: "12px",
          }}
        >
          <DonutChart isGold={isGold} result={result} />
          {/* <DonutChart2 /> */}
          {/* <Test2/> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "2rem auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <div>Invested amount:</div>
              <div>Expected returns (12%):</div>
              <div>Estimated {isGold ? "Gold" : "Silver"} (in gm):</div>
            </div>
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <div>Saving amount:</div>
              <div>Est. returns (12%):</div>
              <div>Expected {isGold ? "Gold" : "Silver"} (in g):</div>
            </div> */}
            <div
              style={{
                fontWeight: "500",
                fontSize: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <div>₹{result.investAmt || 0}</div>
              <div>₹{Number(result.estReturn).toFixed(2)}</div>
              <div>{Number(result.exptQty || 0).toFixed(3)}gm</div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            <div>Total Value:</div>
            {/* <div>Total Savings:</div> */}
            <div>₹{Number(result.totalSaving || 0).toFixed(2)}</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1.5rem",
          }}
        >
          <CustomButton
            label={isGold ? "Buy Gold" : "Buy Silver"}
            onClick={handleBuyGold}
          />
        </div>
      </div>
    </div>
  );
};

export default SipCalculator;
